export class ButtonHelper {
    toggleOcIconButtonLoading(button: HTMLElement, forceShowButton: boolean): void {
        if (forceShowButton) {
            button.removeAttribute('loading');
            button.removeAttribute('disabled');
        } else {
            button.setAttribute('disabled', 'true');
            button.setAttribute('loading', 'true');
        }
    }

    toggleLoading(buttons: HTMLElement | NodeListOf<HTMLElement>, forceShowButton: boolean = false): void {
        if (buttons) {
            if ('length' in buttons) {
                Array.from(buttons).forEach(button => {
                    this.toggleOcIconButtonLoading(button, forceShowButton);
                });
            } else {
                this.toggleOcIconButtonLoading(buttons, forceShowButton);
            }
        }
    }

    static initialize(): void {
        const o_order = window.o_order ?? {};
        o_order.common = o_order.common ?? {};
        o_order.common.buttons = o_order.common.buttons ?? new ButtonHelper();
    }
}
